export const buttons = () => ({
    display: 'grid',
    // '0fr': preserve initial elements width, don't strech them to the cell width
    gridTemplateColumns: 'repeat(2, 0fr)',
    gridColumnGap: 20,
});
